import React from 'react';
import { Flex, Box, Image } from "@chakra-ui/react";
import { StyleSheet, css } from "aphrodite";
import { useSelector } from "react-redux";
import Carousel from './Carousal';
import MobileCarousel from './MobileCarousal';
import Carousal2  from './Carousal2';
import MobileCarousel2 from './MobileCarousal2';


function HomePage() {
    const isMobile = useSelector(state => state.windowSize.isMobile);
  return (
    <>
    
        {isMobile ? 
        (<>
            <MobileCarousel/>
        </>) : 
        (<>
            <Carousel/>
        </>)}


        <Box className={css(styles.parent)}>
            <Flex className={css(styles.container)}>
                MISSION
            </Flex>
            <Box className={css(styles.textbox)}>
                <b>SITE-CAV</b> aims to enable the seamless integration of connected and autonomous vehicles 
                (CAVs) into Ontario’s evolving transportation ecosystem by advancing research in secure, intelligent, 
                and legally-aware decision-making systems. Through interdisciplinary collaboration, cutting-edge experimental 
                testbeds, and industry partnerships, the project seeks to develop resilient communication protocols, 
                security-by-design frameworks, and next-generation mobility solutions.
            </Box>
        </Box>
        <hr />

        {isMobile ? 
        (<>
            <Flex justifyContent="center">
            <Image
                src="home-img-1.png"
                style={{
                    align:'center',
                    width: '85%',
                    height: '75%',
                    marginTop:'10px',
                    marginBottom:'10px',
                    display:'flex'
                }}
                />
        </Flex>
        </>) : 
        (<>
            <Flex justifyContent="center">
            <Image
                src="home-img-1.png"
                style={{
                    align:'center',
                    width: '45%',
                    height: '35%',
                    marginTop:'10px',
                    marginBottom:'10px',
                    display:'flex'
                }}
                />
        </Flex>
        </>)}

        <hr />
        <Box className={css(styles.parent)}>
            <Flex className={css(styles.container)}>
                VISION
            </Flex>
            <Box className={css(styles.textbox)}>
                The vision of SITE-CAV is to pioneer a secure, efficient, and trustworthy ecosystem for CAVs, 
                where intelligent transportation systems seamlessly adapt to technological advancements and 
                societal needs. By bridging AI-driven decision support, ultra-fast connectivity, 
                and legal-aware automation, the project aspires to set new global standards in autonomous 
                mobility and smart infrastructure.
            </Box>
        </Box>
        <hr />

        {isMobile ? 
        (<>
            <MobileCarousel2/>
        </>) : 
        (<>
            <Carousal2/>
        </>)}
        
        <hr />
        <Box className={css(styles.parent)}>
            <Flex className={css(styles.container)}>
                GOAL
            </Flex>
            <Box className={css(styles.textbox)}>
                SITE-CAV's primary goal is to develop, test, and commercialize innovative solutions that enhance 
                the safety, reliability, and efficiency of CAVs within complex urban and intercity environments. 
                By leveraging state-of-the-art research, experimental testbeds, and industry-driven insights, 
                the project aims to shape policies, optimize supply chains, and strengthen cybersecurity measures 
                for the future of autonomous transportation.
            </Box>
        </Box>
        <hr />
    </>
  )
};

const styles = StyleSheet.create({
    parent: {
        maxWidth: '100vw',
    },
    container: {
        maxWidth: '100%',
        justifyContent: 'center',
        fontSize: 24,
        margin: '1%',
        fontWeight: 'bolder',
        textShadow: '1px 1px gray',
    },
    textbox: {
        margin: '3%',
        marginTop: '0%',
        fontSize: 18,
        textAlign:'justify'
    },
    names: {
        fontWeight: 'bold',
        fontSize: 20
    },
    title: {
        fontSize: 18,
    }
})

export default HomePage